import { render, staticRenderFns } from "./FormulationStockInventory.vue?vue&type=template&id=377c1658&scoped=true&"
import script from "./FormulationStockInventory.vue?vue&type=script&lang=js&"
export * from "./FormulationStockInventory.vue?vue&type=script&lang=js&"
import style0 from "./FormulationStockInventory.vue?vue&type=style&index=0&id=377c1658&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377c1658",
  null
  
)

export default component.exports